export enum Frequency {
  Monthly = 'Monthly',
  Yearly = 'Yearly',
}

export enum YesOrNo {
  Yes = 'Yes',
  No = 'No',
}

export enum PoundOrPercent {
  Pound = '£',
  Percent = '%',
}

export interface AEMError {
  title: string;
  body: string;
  button: string;
  link: string;
}
export interface CTCParsedOutputModel {
  ActualCostToYou: string;
  Annuity: string;
  FundExhausionAge: string;
  ProjectedFund_Monetary: string; // eslint-disable-line
  ProjectedFund_Real: string; // eslint-disable-line
  ResidualFundAfterTax: string;
  ResidualFundBeforeTax: string;
  TFC: string;
  TaxDue: string;
  TotalContribution: string;
  TotalEmployeeContributions: string;
  TotalEmployerContributions: string;
  TotalNetContributions: string;
  TotalPotentialGrowth: string;
  TotalTaxRelief: string;
  growthLevel: string;
}
export interface RequestPayload {
  dateOfBirth: string;
  salary: number;
  contributions: {
    amount: number;
    employerAmount: number;
  };
  fundsBalance: number;
  target: number;
  retirementDate: string;
  percentiles: number[];
  terms: number[];
  termsForDrawdownForecast: number[];
}

export interface SectionWrapperModel {
  age: number;
  neededMoney: number;
  totalValue: number;
  withdrawalAge: number;
  scottishTaxPayer: YesOrNo;
  stillPaying: YesOrNo;
  employeeContribution?: number;
  employeeContributionType?: PoundOrPercent;
  employerContribution?: number;
  employerContributionType?: PoundOrPercent;
  income?: number;
  incomeFrequency?: Frequency;
}

// Content dictionary
export interface Content {
  analytics: Analytics;
  inputfields: Inputfields;
  inputs: Inputs;
  outputs: Outputs;
}

export interface Analytics {
  button: Button;
  toggle: string;
}

export interface Button {
  calculate: string;
  edit: string;
}

export interface Inputfields {
  placeholder: Placeholder;
  pound: string;
  percent: string;
  yes: string;
  no: string;
  errors: Errors;
}

export interface Placeholder {
  enterAge: string;
  enterAmount: string;
  enterAmountOptional: string;
}

export interface Errors {
  isRequired: string;
  isNumber: string;
  isInteger: string;
  isMoreThan0: string;
  isFiftyFiveOrMore: string;
  isEighteenOrMore: string;
  isEightyOrLess: string;
  isOneHundredOrLess: string;
  isLessThanOneMillion: string;
  isTenMillionOrLess: string;
  isDateValid: string;
  isOver18: string;
  isAfter1900: string;
  isInThePast: string;
  isPercentage: string;
  isEqualOrMoreThanCurrentAge: string;
  isAgeOver80: string;
}

export interface Inputs {
  assumptions: Assumptions;
  age: InputLabelTooltip;
  aboutYou: AboutYou;
  scottishTaxPayer: InputLabelTooltip;
  stillPaying: InputLabelTooltip;
  plans: Plans;
  contributions: Contributions;
  cta: CtaOrBackButton;
}

export interface Assumptions {
  text: string;
}

export interface InputLabelTooltip {
  label: string;
  tooltip: string;
}

export interface Plans {
  title: string;
  totalValue: InputLabelTooltip;
  withdrawalAge: InputLabelTooltip;
  neededMoney: InputLabelTooltip;
}

export interface AboutYou {
  title: string;
}

export interface Contributions {
  title: string;
  income: InputLabelTooltip;
  salarySacrifice: InputLabelTooltip;
  employeeContribution: InputLabelTooltip;
  employerContribution: InputLabelTooltip;
}

export interface CtaOrBackButton {
  label: string;
}

export interface Outputs {
  error: Error;
  summary: Summary;
  slider: Slider;
  options: Options;
  thingsToConsider: ThingsToConsider;
  needAdvice: NeedAdvice;
  nextStep: NextStep;
}

export interface Error {
  title: string;
  text: string;
  cta: CtaOrBackButton;
}

export interface Summary {
  text1: string;
  text: Text;
  text2: string;
  text3: string;
}

export interface Text {
  glossarytooltip: GlossaryTooltip;
}

export interface GlossaryTooltip {
  term: string;
  content: string;
}
export interface Slider {
  title: string;
  text1: string;
  text: Text1;
  text2: string;
  text3: string;
  label1: string;
  label2: string;
  label3: string;
}

export interface Text1 {
  glossarytooltip1: GlossaryTooltip;
  glossarytooltip2: GlossaryTooltip;
}

export interface Options {
  introHeading: string;
  assumptions: Assumptions;
  taxfreelumpsum: string;
  or: string;
  guaranteedincomebox: Guaranteedincomebox;
  flexibleIncomeBox: FlexibleIncomeBox;
  cashBox: CashBox;
  backButton: CtaOrBackButton;
  combinationBox: OptionsBox;
  leaveItBox: OptionsBox;
}

export interface Guaranteedincomebox {
  title: string;
  guaranteedincome: string;
  forLife: string;
  bodyText1: string;
  glossarytooltip: GlossaryTooltip;
  bodyText2: string;
  linkText: string;
}

export interface FlexibleIncomeBox {
  title: string;
  dipInto: string;
  leavingTheRest: string;
  takeAnnual: string;
  until: string;
  age: string;
  bodyText1: string;
  glossarytooltip: GlossaryTooltip;
  bodyText2: string;
  linkText: string;
  tooltip: string;
}

export interface CashBox {
  title: string;
  remaining: string;
  plusTaxFree: string;
  incomeTax: string;
  cashInfo: string;
  linkText: string;
}

export interface OptionsBox {
  title: string;
  bodyText: string;
  linkText: string;
}

export interface ThingsToConsider {
  title: string;
  bodyText: string;
}

export interface NeedAdvice {
  heading: string;
  bodyText: string;
}

export interface NextStep {
  title: string;
  intro: string;
  phone: string;
  openingTimes: string;
  numberInfo: string;
  numberLabel: string;
  numberLoading: string;
  numberError: string;
  infoBox: string;
}



// WEBPACK FOOTER //
// ./src/interfaces.ts